@if (active) {
<kendo-dialog (close)="closeForm()" [width]="600" [height]="320">
  <kendo-dialog-titlebar>
    Project Estimate Notes
  </kendo-dialog-titlebar>
  <div class="k-form">
    <form novalidate [formGroup]="editForm">
      <div class="form-group row">
        <label for="RecordDescription" class="col-2 control-label">Notes</label>
        <textarea kendoTextArea formControlName="RecordDescription" placeholder="" [(ngModel)]="notes" rows="4" [maxlength]="maxChars" class='form-control'></textarea>
      </div>
    </form>
    <label class="ms-auto"> Characters Remaining: {{notes?.length}}/{{maxChars}}</label>
  </div>
  <kendo-dialog-actions>
    <button type="button" class="k-button" (click)="onCancel($event)">Cancel</button>
    <button type="button" class="k-button k-primary" [disabled]="editForm.pristine" (click)="onSave($event)">Save</button>
  </kendo-dialog-actions>
</kendo-dialog>
}